import { Component, HostListener, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { AppService } from './app.service';
declare let $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit, OnDestroy {
  routerSubscription: any;

  constructor(private router: Router, public appservice: AppService) { }

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.keyCode == 115) {
      this.router.navigate([this.appservice.Sales_Entry_Page]);
    }

    if (event.keyCode == 116) {
      this.router.navigate([this.appservice.Purchase_entry_page]);
    }
  }

  ngOnInit() {
    this.recallJsFuntions();

    window.addEventListener('keyup', disableF5);
    window.addEventListener('keydown', disableF5);

    function disableF5(e) {
      if ((e.which || e.keyCode) == 116) e.preventDefault();
      if ((e.which || e.keyCode) == 117) e.preventDefault();
    }
  }

  recallJsFuntions() {
    this.routerSubscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        $.getScript('../assets/js/custom.js');
        this.appservice.URL_Location = this.router.url;

        if (this.router.url.toString().substr(0, 5) == '/?id=') {
          localStorage.setItem('FID', this.router.url.toString().replace('/?id=', ''));
        }

        window.scrollTo(0, 0);
      });
  }

  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }
}
